export default __webpack_public_path__ + "static/media/do i get to keep this body.10741df9.jpg";